<dx-tree-list *ngIf="dataSource?.length"
    id="gridContainer"
    [dataSource]="dataSource"
    keyExpr="objetId"
    parentIdExpr="parentId"
    width="100%"
    [autoExpandAll]="true"
    [allowColumnResizing]="true"
    [allowColumnReordering]="true"
    (onToolbarPreparing)="onToolbarPreparing($event)"
    >

  <dxo-column-chooser [enabled]="true" mode="select" [height]="600"></dxo-column-chooser>

  <dxo-filter-row
    [visible]="true"
  ></dxo-filter-row>

  <dxo-state-storing
    [enabled]="true"
    [storageKey]="'grille_bon_detail_photos'"
    appStorage
  ></dxo-state-storing>

  <dxi-column dataField="objetId" caption="Object id" [visible]="false"></dxi-column>

  <dxi-column dataField="utilisateur" caption="Utilisateur"></dxi-column>

  <dxi-column dataField="codeArticle" caption="Code Article" [width]="100"></dxi-column>

  <dxi-column dataField="libelle" caption="Libelle" [width]="250"></dxi-column>

  <dxi-column dataField="quantiteUA" caption="Quantité UA" [width]="105"></dxi-column>

  <dxi-column dataField="uniteUA" caption="Unité UA" [width]="100"></dxi-column>

  <dxi-column dataField="quantiteUV" caption="Quantité UV" [visible]="false" [width]="105"></dxi-column>

  <dxi-column dataField="uniteUV" caption="Unité UV" [visible]="false" [width]="100"></dxi-column>

  <dxi-column dataField="quantite" caption="Quantité UB" [visible]="false" [width]="105"></dxi-column>

  <dxi-column dataField="uniteBase" caption="Unité Base" [visible]="false" [width]="100"></dxi-column>

  <dxi-column caption="Photos" cellTemplate="photoIdsCellTemplate" [width]="100"></dxi-column>
    <div *dxTemplate="let data of 'photoIdsCellTemplate'">
      <dx-button *ngIf="data.data?.photosIds"
        icon="image"
        [text]="data.data.photosIds.length"
        (onClick)="displayPhotos(data.data)"
      >
      </dx-button>
    </div>

  <dxi-column dataField="createdOn" caption="Date création"  dataType="date" [width]="155" format="dd/MM/yyyy HH:mm:ss"></dxi-column>

  <dxi-column dataField="nomFournisseur" caption="Fournisseur" [width]="170"></dxi-column>

  <dxi-column dataField="refFournisseur" caption="Réf. fournisseur" [width]="105"></dxi-column>

  <dxi-column dataField="dlc" caption="DLC"></dxi-column>

  <dxi-column dataField="sousObjetType" caption="Type d'object" [visible]="false"></dxi-column>

</dx-tree-list>

<dx-popup
  [(visible)]="isPhotoPopupVisible"
  title="Photos"
  height="95vh"
  minWidth="700px"
  maxWidth="1000px"
  [resizeEnabled]="true"
>
  <dx-scroll-view>
    <div *ngFor="let photo of currentPhotos" style="height:85vh; display: flex; justify-content: center;">
      <img [src]="photo" class="popup-img" style="height:100%">
    </div>
  </dx-scroll-view>

</dx-popup>